import { create } from "zustand";
import type { CallStatus } from "./types";

interface DialerState {
	// Dialer UI
	open: boolean;
	minimized: boolean;
	numberToCall: string;
	fromNumber: string;
	countryCode: string;

	// Call state
	callStatus: CallStatus;
	isCalling: boolean;
	isMuted: boolean;
	callDuration: number;
	isClientReady: boolean;

	// New feature state
	isConnected: boolean;
	isNoiseReductionOn: boolean;
	showFeedback: boolean;
	lastCallUUID: string;

	// Dialer UI actions
	openDialer: (number?: string) => void;
	closeDialer: () => void;
	setMinimized: (v: boolean) => void;
	setNumberToCall: (n: string) => void;
	setFromNumber: (n: string) => void;
	setCountryCode: (c: string) => void;

	// Call state actions
	setCallStatus: (s: CallStatus) => void;
	setIsCalling: (v: boolean) => void;
	setIsMuted: (v: boolean) => void;
	setCallDuration: (v: number) => void;
	incrementCallDuration: () => void;
	setIsClientReady: (v: boolean) => void;
	resetCallState: () => void;
}

export const useDialerStore = create<DialerState>((set) => ({
	open: false,
	minimized: false,
	numberToCall: "",
	fromNumber: "",
	countryCode: "global",

	callStatus: "",
	isCalling: false,
	isMuted: false,
	callDuration: 0,
	isClientReady: false,

	isConnected: false,
	isNoiseReductionOn: false,
	showFeedback: false,
	lastCallUUID: "",

	openDialer: (number = "") =>
		set({ open: true, minimized: false, numberToCall: number }),
	closeDialer: () =>
		set({
			open: false,
			minimized: false,
			numberToCall: "",
			countryCode: "global",
		}),
	setMinimized: (v) => set({ minimized: v }),
	setNumberToCall: (n) => set({ numberToCall: n }),
	setFromNumber: (n) => set({ fromNumber: n }),
	setCountryCode: (c) => set({ countryCode: c }),

	setCallStatus: (s) => set({ callStatus: s }),
	setIsCalling: (v) => set({ isCalling: v }),
	setIsMuted: (v) => set({ isMuted: v }),
	setCallDuration: (v) => set({ callDuration: v }),
	incrementCallDuration: () =>
		set((state) => ({ callDuration: state.callDuration + 1 })),
	setIsClientReady: (v) => set({ isClientReady: v }),
	resetCallState: () =>
		set({ callStatus: "", isCalling: false, isMuted: false, callDuration: 0 }),
}));
